export default __webpack_public_path__ + "static/media/close-wel.c3be73bc.svg";